import { exportUserSession, globalFetchOptions } from '~/utils/helpers';
import { AssistanceType } from '~/composables/types/AssistanceType';

const fetchOptions = () => {
  const config = useRuntimeConfig();
  // check cookie.value if value does not exist then take the value from localStorage
  const cookie = exportUserSession();
  return {
    baseURL: config.public.adminToolsApiBase as string,
    headers: {
      Authorization: `Bearer ${cookie.value}`,
    },
  };
};

export class IntegrationModel {
  static checkIntegrationEnabled = () => {
    const config = useRuntimeConfig();
    return $fetch<{ success: boolean; data: boolean }>(`/faqs/modules/SAHelp/enabled`, {
      ...fetchOptions(),
      method: 'get',
    });
  };

  static checkFoodIntegrationEnabled = () => {
    const config = useRuntimeConfig();
    return $fetch<{ success: boolean; data: boolean }>(`/assistance-types/food/allowed`, {
      ...globalFetchOptions(),
      method: 'get',
    });
  };

  static checkServiceIntegrationEnabled = (id: string) => {
    const config = useRuntimeConfig();
    return $fetch<{ success: boolean; data: boolean }>(`/assistance-types/${id}/allowed`, {
      ...globalFetchOptions(),
      method: 'get',
    });
  };

  // Array form of checkServiceIntegrationEnabled: returns every assistance type the
  // current user is allowed to access, so menus can be built generically instead of
  // probing one hard-wired id at a time.
  static getAllowedAssistanceTypes = () => {
    return $fetch<{ success: boolean; data: AssistanceType[] }>(`/assistance-types/distributable/allowed`, {
      ...globalFetchOptions(),
      method: 'get',
    });
  };

  static checkDisasterIntegrationEnabled = () => {
    const config = useRuntimeConfig();
    return $fetch<{ success: boolean; data: boolean }>(`/assistance-types/disaster/allowed`, {
      ...globalFetchOptions(),
      method: 'get',
    });
  };
}
